// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-nL4zn";
var _5 = "header-Xzarx";
var _6 = "info-RO1VN";
var _7 = "date-1wCj1";
var _8 = "direction-1p1UP";
var _9 = "type-3iwDH";
var _a = "prices-12MGO";
var _b = "price-T7GTg";
var _c = "money-dglnR";
var _d = "passengers-3Ekwz";
var _e = "passenger-1uzZl";
var _f = "number-254KO";
var _10 = "label-1pIHJ";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "header", _6 as "info", _7 as "date", _8 as "direction", _9 as "type", _a as "prices", _b as "price", _c as "money", _d as "passengers", _e as "passenger", _f as "number", _10 as "label" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "header": _5, "info": _6, "date": _7, "direction": _8, "type": _9, "prices": _a, "price": _b, "money": _c, "passengers": _d, "passenger": _e, "number": _f, "label": _10 }
